define([
	"./_TextStyle",
	"./PluginFactory"
], function(_TextStyle,PluginFactory) {

	return PluginFactory.declare(_TextStyle, {
		"class": "csi-button-toggle csi-toggle-group-last",
		cssValue: "s",
		materialIcon: "strikethrough_s",
		pluginName: "strikethrough",
		title: "CanvasStrikeThrough"
	});
});
